// extracted by mini-css-extract-plugin
module.exports =  {"popover-content":"_7506d987b5--popover-content--RiIlC","popover-list":"_7506d987b5--popover-list--pNZK4","popover-list-item":"_7506d987b5--popover-list-item--jyT_7"};